if (!customElements.get("custom-mock-dropdown")) {
  customElements.define(
    "custom-mock-dropdown",
    class extends HTMLElement {
      constructor() {
        super();
        this.isOpen = false;
        this.currentValue = $(this).find("li.selected").data("value");

        this.dropdownTrigger = $(this).find('.custom-dropdown-trigger');
        
        this.dropdownContent = $(this).find('.custom-mock-dropdown-content');

        this.openDropdown = this.openDropdown.bind(this);
        this.closeDropdown = this.closeDropdown.bind(this);
        this.handleItemClick = this.handleItemClick.bind(this);

        this.variantJSONScript = document.getElementById("VariantImageJson");
      }
      connectedCallback() {
        this.dropdownTrigger.on("click", this.openDropdown);

        $(document).on("click", this.closeDropdown);
        this.dropdownContent.on("click", this.handleItemClick);

        if(this.variantJSONScript){
          this.loadImages();
        }
      }

      loadImages(){
        const productVariants = JSON.parse(this.variantJSONScript.textContent);
        
        this.dropdownContent.find('li').each((index, label) => {
          const labelText = label.dataset.value;
          const matchingVariant = productVariants?.find((variant) =>
            variant.color_option == labelText
          );
          if(!matchingVariant) return;

          const imageElement = label.querySelector(".variant_image");
          if(!imageElement){
            console.error("No image element found inside:", label);
            return;
          }

          if (matchingVariant.image) {
            const src = `${window.location.origin}/cdn/shop/${matchingVariant.image}?width=50`;
            imageElement.style.display = "block";
            imageElement.src = src;
            imageElement.srcset = src;
          } else {
            imageElement.style.display = "none";
          }
        });
      }

      handleItemClick(e){
        if(e.target.tagName != "LI") return;

        const value = e.target.dataset.value;
        if(value == this.currentValue) return;

        this.currentValue = value;

        $(this).find("li.selected").removeClass("selected");
        e.target.classList.add("selected");

        const matchingInput = this.closest("variant-selects")?.querySelector(`input[value='${value}'][name='Color']`);
        if(matchingInput){
          matchingInput.checked = true;
          matchingInput.dispatchEvent(new Event("change", {
            bubbles: true,
          }));
        }
      }

      openDropdown() {
        this.isOpen = true;
        $(this).addClass("active");
        this.dropdownContent.slideDown(200);
      }

      closeDropdown(e) {
        if(!this.dropdownTrigger.is(e.target) && this.dropdownTrigger.has(e.target).length === 0) {
          this.isOpen = false;
          $(this).removeClass("active");
          this.dropdownContent.slideUp(200);
        }
      }
    }
  );
}